<template>
  <common-default-layout
    :spring-size="springSize"
    :small-header="smallHeader"
    :is-aw-spring="isAwSpring"
    :spring-desktop-size="springDesktopSize"
  >
    <template v-if="$slots.categoryMenu" #categoryMenu />
    <template #content="{ defaultLayoutClasses }">
      <slot name="content" :default-layout-classes="defaultLayoutClasses">
        <div :class="[defaultLayoutClasses.container]">
          <slot />
        </div>
      </slot>
    </template>
    <template #before-footer>
      <aw-catalog-footer-block />
    </template>
    <template #modal>
      <aw-shop-modals />
    </template>
  </common-default-layout>
</template>

<script>
  import CommonDefaultLayout from '~~/common/layouts/default';
  import AwShopModals from '~~/shop/app/components/Common/Modals/AwShopModals.vue';
  import { defineLazyHydrationComponent } from '#app/composables/lazy-hydration';

  const AwCatalogFooterBlock = defineLazyHydrationComponent('visible', () => import('~~/shop/app/components/AwCatalogFooterBlock.vue'));

  export default {
    name: 'ShopDefaultLayout',
    components: {
      AwShopModals,
      AwCatalogFooterBlock,
      CommonDefaultLayout,
    },
    props: {
      springSize: {
        type: [String, Boolean],
        default: 'md',
      },
      springDesktopSize: {
        type: Number,
        default: undefined,
      },
      isAwSpring: {
        type: Boolean,
        default: false,
      },
      smallHeader: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: $color-seashell;
}

.container {
  flex: 1;
  margin-top: 60px;
  padding-bottom: 24px;

  @include md(max) {
    margin-top: 24px;
    padding-bottom: 16px;
  }
}

.overflowHidden {
  overflow: hidden;
}

.sticky {
  position: sticky;
  z-index: 7;
  top: 0;
}

.headerSearch {
  margin: 16px;

  &Wrapper {
    position: relative;
    width: 100%;
    max-width: 288px;
    margin: auto;
  }

  &Bar {
    width: 100%;
    max-width: 288px;
    height: 56px;
    padding: 8px 56px 8px 16px;
    border: 1px solid $color-alto;
    border-radius: 8px;
    background: $color-white;
  }

  &Icon {
    position: absolute;
    top: 16px;
    right: 16px;
    bottom: 16px;
  }
}
</style>
